import { EventEmitter } from "@src/js/utils/EventEmitter";
export var TimerManagerEvents;
(function (TimerManagerEvents) {
    TimerManagerEvents["INACTIVITY_TIMEOUT"] = "inactivityTimeout";
    TimerManagerEvents["TIME_UP"] = "timeUp";
})(TimerManagerEvents || (TimerManagerEvents = {}));
/**
 * TimerManager
 *
 * Handles inactivity timeout and runtime timer logic.
 * Emits events:
 * - 'inactivityTimeout' (no payload)
 * - 'timeUp' (no payload)
 */
export class TimerManager extends EventEmitter {
    constructor(inactivityTimeoutMs, runtimeSeconds) {
        super();
        this.inactivityTimer = null;
        this.runtimeInterval = null;
        this.inactivityTimeoutMs = inactivityTimeoutMs;
        this.runtimeSeconds = runtimeSeconds;
        this.remainingSeconds = runtimeSeconds;
    }
    /**
     * Starts the inactivity timer.
     */
    startInactivityTimer() {
        this.clearInactivityTimer();
        this.inactivityTimer = setTimeout(() => {
            this.emit(TimerManagerEvents.INACTIVITY_TIMEOUT);
        }, this.inactivityTimeoutMs);
    }
    /**
     * Resets the inactivity timer.
     */
    resetInactivityTimer() {
        this.startInactivityTimer();
    }
    /**
     * Clears the inactivity timer.
     */
    clearInactivityTimer() {
        if (this.inactivityTimer) {
            clearTimeout(this.inactivityTimer);
            this.inactivityTimer = null;
        }
    }
    /**
     * Starts the runtime timer.
     */
    startRuntimeTimer() {
        this.clearRuntimeTimer();
        this.remainingSeconds = this.runtimeSeconds;
        this.runtimeInterval = window.setInterval(() => {
            if (this.remainingSeconds > 0) {
                this.remainingSeconds -= 1;
            }
            else {
                this.clearRuntimeTimer();
                this.emit(TimerManagerEvents.TIME_UP);
            }
        }, 1000);
    }
    /**
     * Clears the runtime timer.
     */
    clearRuntimeTimer() {
        if (this.runtimeInterval !== null) {
            clearInterval(this.runtimeInterval);
            this.runtimeInterval = null;
        }
    }
    /**
     * Returns the remaining time in seconds.
     */
    getRemainingSeconds() {
        return this.remainingSeconds;
    }
    /**
     * Returns the remaining time formatted as MM:SS.
     */
    getFormattedTime() {
        const min = Math.floor(this.remainingSeconds / 60);
        const sec = this.remainingSeconds % 60;
        return `${String(min).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
    }
    /**
     * Destroys all timers and listeners.
     */
    destroy() {
        this.clearInactivityTimer();
        this.clearRuntimeTimer();
        this.removeAllListeners();
    }
}
